<template>
  <div>
    <span class="hidden-xs-up">
      {{ data.lastCommentDate | shortDate }}
    </span>{{ data.lastCommentDate | shortDate }}
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'DateLastCommentTag',
  props: {
    data: {
      required: true,
      type: Object
    }
  }
}
</script>
